// extracted by mini-css-extract-plugin
export default {"linkButton":"styles-module__linkButton__src-labstep-web-components-UserGroup-Table-_Az3c6"};